
import { RubroMovimientoCaja } from "./movimientocaja";
import { TipoMovimientoCajaView, OrigenMovimientoCaja } from "./movimientocajaview";
import { FormaPagoMovimientoCaja } from "./movimientocaja";

/**Una asignacion de una caja a un usuario, la cual dura lo que dure el turno asignado */
export interface CajaTurno {
    /**Id del turno */
    IdTurno: number;

    /**Rubo de la caja */
    RubroCaja: RubroMovimientoCaja;

    /**La caja relacionada */
    IdCaja: number;
}

/**Estatus del turno */
export enum StatusTurno {
    /**El usuario actual tiene activo ese turno */
    Activo,

    /**El turno ya terminó */
    Finalizado
}

/**Un turno del sistema, indica que cajas tiene activas el usuario actual */
export interface Turno {
    IdRegistro: number;

    /**Fecha en la que el usuario entró a ese turno */
    FechaEntrada: Date;

    /**Fecha de salida del turno. Se verifica ccon un CHECK que esta sea null cuando el status == Activo, pero que tenga valor cuando status == Finalizado */
    FechaSalida: Date | null;

    /**Status del turno */
    Status: StatusTurno;

    /**Usuario de este turno */
    IdUsuario: number;

    /**
         * Listado de @see CajaTurno  relacionado con esta entidad
         */
    CajaTurnos: CajaTurno[];

    /**Id de la caja a la que se va a trasladar todo el dinero del turno al hacer el corte */
    IdCajaAdministrativa: number;

    /**Sucursal del turno. Se guarda ya que puede ser que la sucursal de la caja administrativa cambie asi que no se puede obtener de ahí este valor */
    IdSucursal: number;
}
/**DTO de un turno asignado al usuario */
export interface TurnoDto extends Turno {
    Cajas: CajasTurnoDto;

    NombreUsuario: string;

    /**Nombre de la sucursal del usuario */
    NombreSucursal: string;

    /**Nombre de la caja administrativa para este turno */
    NombreCajaAdministrativa: string;
}

export interface CajasTurnoDto {
    Documentacion: CajaTurnoDto;
    EntregaDomicilio: CajaTurnoDto;
    EntregaZE: CajaTurnoDto;
    EntregaOcurre: CajaTurnoDto;
    Cobranza: CajaTurnoDto;
    Facturacion: CajaTurnoDto;
    PaquetePP: CajaTurnoDto;
    IdTurno: number;
}

/**Una caja asignada en el turno del usuario */
export interface CajaTurnoDto {
    /**Id de la caja */
    IdCaja: number;
    /**Nombre de la caja */
    Nombre: string;
}

/**Modelo para la creación de un nuevo turno de caja */
export interface NuevoTurnoModel {
    /**Usuario que va a iniciar el turno */
    IdUsuario: number;

    /**Asignaciones de las cajas */
    CajaTurnos: NuevoTurnoAsignacionCaja[];

    /**Id de la sucursal del turno */
    IdSucursal: number;
}

/**Asignacion de una caja a un rubro */
export interface NuevoTurnoAsignacionCaja {
    /**Rubro de la caja */
    RubroCaja: RubroMovimientoCaja;

    /**La caja relacionada */
    IdCaja: number;
}

export interface FiltroTurno {
    IdSucursal?: number | null;
    IdUsuario?: number | null;
    FechaEntradaInicio?: Date | string | null;
    FechaEntradaFinal?: Date | string | null;

    FechaSalidaInicio?: Date | string | null;
    FechaSalidaFinal?: Date | string | null;

    Limite?: number | null;
}

export interface SaldosCaja {
    Movimientos: Movimientos[];
    SaldosIniciales: ImporteCaja[];
}

export interface ImporteCaja {
    IdRegistro: number;
    Nombre: string;
    Saldo: number;
}

export interface Movimientos {
    FormaPago: FormaPagoMovimientoCaja;
    Fecha: Date | string;
    TipoMovimiento: TipoMovimientoCajaView;
    IdCaja: number;
    NombreCaja: string;
    Importe: number;
    TipoOrigen: OrigenMovimientoCaja;
    IdOrigen: number;
}



// WEBPACK FOOTER //
// ./app/models/turno.ts